import React from 'react';
import RecentReports from './CustomCards/RecentReports/RecentReports';
import SurveyUtilization from './CustomCards/SurveyUtilization/SurveyUtilization';
import MarketAnalysis from './CustomCards/MarketAnalysis/MarketAnalysis';
import MarketPricing from './CustomCards/MarketPricing/MarketPricing';
import StatisticsBar from './CustomCards/StatisticsBar/StatisticsBar';
import RecentJobs from './CustomCards/RecentJobs/RecentJobs';

const cardMappings = {
  1: {
    title: 'Recent Reports',
    minW: 1,
    maxW: 2,
    minH: 2,
    maxH: 3,
    thumbnail: '/view/static/mp/images/CardThumbnails/reports.png',
    component: <RecentReports />
  },
  2: {
    title: 'Survey Utilization',
    minW: 1,
    maxW: 2,
    minH: 3,
    maxH: 3,
    thumbnail: '/view/static/mp/images/CardThumbnails/survey.png',
    component: <SurveyUtilization />
  },
  3: {
    title: 'Market Analysis',
    minW: 2,
    maxW: 3,
    minH: 2,
    maxH: 3,
    thumbnail: '/view/static/mp/images/CardThumbnails/market_analysis.png',
    component: <MarketAnalysis />
  },
  4: {
    title: 'Statistics Bar',
    minW: 2,
    maxW: 3,
    minH: 1,
    maxH: 3,
    thumbnail: '/view/static/mp/images/CardThumbnails/quick_stats.png',
    component: <StatisticsBar />
  },
  5: {
    title: 'Market Pricing',
    minW: 2,
    maxW: 3,
    minH: 2,
    maxH: 3,
    thumbnail: '/view/static/mp/images/CardThumbnails/job_pricing_overview.png',
    component: <MarketPricing />
  },
  6: {
    title: 'Recently Updated Jobs',
    minW: 1,
    maxW: 3,
    minH: 2,
    maxH: 3,
    thumbnail: '/view/static/mp/images/CardThumbnails/job_pricing_overview.png',
    component: <RecentJobs />
  }
};

export default cardMappings;
